import {
  ConditionalOperator,
  CustomSqlCloudTestConfig,
  QualityDimension,
} from 'shared/types';

export const enforcementLevelOptions = [
  { value: 'all', label: 'All changes' },
  { value: 'breaking', label: 'Breaking changes only' },
  { value: 'downstream', label: 'Downstream impact only' },
  { value: 'downstream_critical', label: 'Critical downstream impact only' },
];

export const thresholdUnitOptions = [
  { value: 'hour', label: 'hours' },
  { value: 'day', label: 'days' },
  { value: 'week', label: 'weeks' },
  { value: 'month', label: 'months' },
];

export const DEFAULT_ANOMALY_TRAINING_PERIOD = {
  period: 'day' as const,
  count: 23,
};

export const isUnsetPeriodCount = (value: unknown): boolean =>
  value == null ||
  value === '' ||
  (typeof value === 'number' && Number.isNaN(value));

export const CUSTOM_SQL_CLOUD_ERROR = {
  STATIC_VALIDATION: 159,
  UNRESOLVABLE_RELATIONS: 160,
  ASSET_SELECTION_REQUIRED: 161,
  INVALID_PRIMARY_ASSET: 162,
  FEATURE_DISABLED: 163,
  INVALID_SCHEDULE: 164,
  NO_STATEMENT_TIMEOUT: 165,
};

export const CUSTOM_SQL_INTERVAL_HOURS = Array.from(
  { length: 23 },
  (_, i) => i + 1,
);

export const CUSTOM_CRON_FORMAT_ERROR = 'Enter a five-field cron expression';
export const CUSTOM_CRON_INVALID_ERROR = 'Invalid cron expression';
export const CUSTOM_CRON_MIN_INTERVAL_MINUTES = 15;
export const CUSTOM_CRON_SCAN_RUNS = 200;
export const MS_IN_MINUTE = 60 * 1000;

export const CUSTOM_SQL_MINUTES = Array.from({ length: 60 }, (_, i) => i);

export const DEFAULT_CLOUD_SQL_TEST_SCHEDULE = {
  scheduleType: 'daily' as const,
  intervalHours: 6,
  scheduleHour: 9,
  scheduleMinute: 0,
  scheduleDayOfWeek: 1,
};

export const CUSTOM_SQL_CONDITIONAL_OPERATORS: ConditionalOperator[] = ['>'];

export const QUALITY_DIMENSIONS: QualityDimension[] = [
  'completeness',
  'uniqueness',
  'freshness',
  'validity',
  'accuracy',
  'consistency',
];

export const WIZARD_YAML_CHAR_LIMIT = 8000;

export const NO_TIMESTAMP_COLUMN_HINT =
  'Optional. With a timestamp column, rows are counted per time bucket and past buckets are backfilled. Without one, the test counts all rows on every run, so history builds up run by run.';

export const NO_UPDATE_TIMESTAMP_COLUMN_HINT =
  'Optional. Without an updated at column, the test measures the time from the latest event to the test run.';

export const MAX_SAMPLE_ROW_LIMIT = 1000;
export const MAX_QUERY_TIMEOUT_SECONDS = 1200;

export const DEFAULT_CUSTOM_SQL_CONFIG: CustomSqlCloudTestConfig = {
  fail_row_count_threshold: 0,
  warn_row_count_threshold: null,
  store_row_sample: true,
  sample_row_limit: 100,
  query_timeout_seconds: 300,
};
